// Auto-generated normalizer for table: CAR_BOOKING.AprobacionesReservas
export function aprobacionesReservasNormalize(row) {
  return {
    idAprovacionesReservas: row.idAprovacionesReservas ?? row.IdAprovacionesReservas ?? row['IdAprovacionesReservas'] ?? 0,
    idReserva: row.idReserva ?? row.IdReserva ?? row['IdReserva'] ?? 0,
    idTipoAprobacion: row.idTipoAprobacion ?? row.IdTipoAprobacion ?? row['IdTipoAprobacion'] ?? 0,
    idEstadoReserva: row.idEstadoReserva ?? row.IdEstadoReserva ?? row['IdEstadoReserva'] ?? 0,
    idAprobadores: row.idAprobadores ?? row.IdAprobadores ?? row['IdAprobadores'] ?? 0,
    fechaAprobacion: row.fechaAprobacion ?? row.FechaAprobacion ?? row['FechaAprobacion'] ?? null,
    comentario: row.comentario ?? row["comentario"] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
